export function CoreClearInputDirective (
  KEYCODES
) {
  return {
    require: 'ngModel',
    scope  : {
      onEmpty: '&'
    },
    link (scope, element, attrs, ctrl) {
      const clearBtn = angular.element(`
        <div class="clear-filter">
          <a href="javascript:void(0)" clear-input="vendorSearch.selected">
            <span><i class="fa fa-times"></i></span>
          </a>
        </div>
      `);

      const clearFn = function () {
        ctrl.$setViewValue(null);
        ctrl.$render();

        scope.$apply();
      };

      const handleKeydown = function ( e ) {
        const keycode = e.keyCode || e.which;

        if (keycode === KEYCODES.esc) {
          clearFn();

          e.stopPropagation();
        }
      };

      element.after(clearBtn);

      clearBtn.on('click', clearFn);

      element.on('keydown', handleKeydown);

      scope.$on('$destroy', () => {
        clearBtn.off('click', clearFn);
        clearBtn.remove();

        element.off('keydown', handleKeydown);
      });

      scope.$watch(() => ctrl.$modelValue, (newVal, oldVal) => {
        if (newVal !== oldVal && !newVal && scope.onEmpty) {
          scope.onEmpty();
        }
      });
    }
  };
}